module.exports = __webpack_public_path__ + "img/img_xinshou_11.cfe54d5e.png";